import AppsIcon from "@mui/icons-material/Apps";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SettingsIcon from "@mui/icons-material/Settings";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { ModalShell } from "./ModalShell";

export function SettingsModal({
  rowButtonsPerRow,
  bayButtonsPerRow,
  showEmptyRows,
  hasItems,
  hasLocations,
  debugEnabled,
  onClose,
  onImport,
  onDeleteAllItems,
  onDeleteAllLocations,
  onRowButtonsPerRowChange,
  onBayButtonsPerRowChange,
  onShowEmptyRowsChange,
  onDebug,
}) {
  return (
    <ModalShell icon={<SettingsIcon />} title="Settings" onClose={onClose}>
      <div className="settings-grid">
        <section className="settings-card">
          <div className="settings-label">
            <ViewModuleIcon /> Row buttons
          </div>
          <div className="density-buttons" aria-label="Row buttons per row">
            {[3, 4, 5, 6].map((value) => (
              <button
                key={value}
                type="button"
                aria-label={`${value} row buttons per row`}
                className={`segmented-button density-button ${
                  Number(rowButtonsPerRow) === value ? "active" : ""
                }`}
                onClick={() => onRowButtonsPerRowChange(value)}
              >
                {value}
              </button>
            ))}
          </div>
        </section>

        <section className="settings-card">
          <div className="settings-label">
            <AppsIcon /> Bay buttons
          </div>
          <div className="density-buttons" aria-label="Bay buttons per row">
            {[3, 4, 5, 6].map((value) => (
              <button
                key={value}
                type="button"
                aria-label={`${value} bay buttons per row`}
                className={`segmented-button density-button ${
                  Number(bayButtonsPerRow) === value ? "active" : ""
                }`}
                onClick={() => onBayButtonsPerRowChange(value)}
              >
                {value}
              </button>
            ))}
          </div>
        </section>

        <button type="button" className="settings-action" onClick={onImport}>
          <FileUploadIcon />
          <span>Import CSV</span>
        </button>

        <button
          type="button"
          className="settings-action danger"
          onClick={onDeleteAllItems}
          disabled={!hasItems}
        >
          <DeleteOutlineIcon />
          <span>Delete all items</span>
        </button>

        <button
          type="button"
          className="settings-action danger"
          onClick={onDeleteAllLocations}
          disabled={!hasLocations}
        >
          <DeleteOutlineIcon />
          <span>Delete all locations</span>
        </button>

        <label className="settings-action toggle">
          <input
            type="checkbox"
            checked={showEmptyRows}
            onChange={(event) => onShowEmptyRowsChange(event.target.checked)}
          />
          <span>Show empty rows</span>
        </label>

        {debugEnabled && (
          <button type="button" className="settings-action" onClick={onDebug}>
            <SettingsIcon />
            <span>Diagnostics</span>
          </button>
        )}
      </div>
    </ModalShell>
  );
}
